import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { get } from './library.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["size", "color", "name", "rotation", "title", "data"];
var StyledSvg = styled.svg.attrs(function (_ref) {
  var $height = _ref.$height,
    $width = _ref.$width,
    fill = _ref.fill;
  return {
    name: null,
    xmlns: 'http://www.w3.org/2000/svg',
    height: "".concat($height, "px"),
    width: "".concat($width, "px"),
    fill: fill
  };
}).withConfig({
  displayName: "Icon__StyledSvg",
  componentId: "sc-6evbi1-0"
})(["transform:", ";"], function (_ref2) {
  var $rotation = _ref2.$rotation;
  return $rotation ? "rotate(".concat($rotation, "deg)") : 'none';
});
var StyledPath = styled.path.attrs(function (_ref3) {
  var $height = _ref3.$height,
    $size = _ref3.$size;
  return {
    size: null,
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    transform: $size / $height !== 1 ? "scale(".concat($size / $height, ")") : null
  };
}).withConfig({
  displayName: "Icon__StyledPath",
  componentId: "sc-6evbi1-1"
})([""]);
var customIcon = function customIcon(icon) {
  return {
    icon: icon,
    count: Math.floor(Math.random() * 1000)
  };
};
var findIcon = function findIcon(name, data, size) {
  // eslint-disable-next-line prefer-const
  var _ref4 = data ? customIcon(data) : get(name),
    icon = _ref4.icon,
    count = _ref4.count;
  if (size < 24) {
    var _icon$sizes;
    // fallback to normal icon if small is not made yet
    icon = ((_icon$sizes = icon.sizes) === null || _icon$sizes === void 0 ? void 0 : _icon$sizes.small) || icon;
  }
  return {
    icon: icon,
    count: count
  };
};
var Icon = /*#__PURE__*/forwardRef(function Icon(_ref5, ref) {
  var size = _ref5.size,
    _ref5$color = _ref5.color,
    color = _ref5$color === void 0 ? 'currentColor' : _ref5$color,
    name = _ref5.name,
    rotation = _ref5.rotation,
    title = _ref5.title,
    data = _ref5.data,
    rest = _objectWithoutProperties(_ref5, _excluded);
  // eslint-disable-next-line prefer-const
  var _findIcon = findIcon(name, data, size),
    icon = _findIcon.icon,
    count = _findIcon.count;
  if (typeof icon === 'undefined') {
    throw Error("Icon \"".concat(name, "\" not found. Have you added it using Icon.add() or using data props?"));
  }
  var $height = size ? size : parseInt(icon.width);
  var $width = size ? size : parseInt(icon.height);
  var svgProps = {
    $height: $height,
    $width: $width,
    fill: color,
    viewBox: "0 0 ".concat($width, " ").concat($height),
    $rotation: rotation,
    name: name,
    'aria-hidden': true
  };
  var pathProps = {
    d: icon.svgPathData,
    $height: icon.height ? parseInt(icon.height) : size,
    $size: size || parseInt(icon.height)
  };

  // Accessibility
  var titleId = '';
  if (title) {
    titleId = "".concat(icon.prefix, "-").concat(icon.name, "-").concat(count);
    svgProps = _objectSpread(_objectSpread({}, svgProps), {}, {
      title: title,
      role: 'img',
      'aria-hidden': undefined,
      'aria-labelledby': titleId
    });
  }
  return /*#__PURE__*/jsxs(StyledSvg, _objectSpread(_objectSpread(_objectSpread({}, svgProps), rest), {}, {
    ref: ref,
    children: [title && /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }), /*#__PURE__*/jsx(StyledPath, _objectSpread({
      "data-testid": "eds-icon-path"
    }, pathProps))]
  }));
});

// Icon.displayName = 'EdsIcon'

export { Icon };
